import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { UserEndpoint } from '../constants/user-endpoint';
import { TruckDriversSearchCriteria, TruckDriverBrief } from '../models';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class TruckDriversService {
  constructor(private http: WrapperHttpService) {}

  getTruckDrivers({ size: _size, page, ...filterView }: TruckDriversSearchCriteria): Observable<TruckDriverBrief[]> {
    const url = `${API_URL}${UserEndpoint.Hubs}${UserEndpoint.DriverData}${
      UserEndpoint.Search
    }?${getQueryStringFromObject({
      page,
      size: 500,
    })}`;
    return this.http.withLoading().post<TruckDriverBrief[]>(url, filterView);
  }

  deleteTruckDriver(
    hubId: number,
    frequentDriverIds: number[],
    truckIds: number[],
    tourExecutionIds: number[],
  ): Observable<TruckDriverBrief> {
    const body = {
      hubId,
      frequentDriverIds,
      truckIds,
      tourExecutionIds,
    };
    const url = `${API_URL}${UserEndpoint.Hubs}${UserEndpoint.DriverData}`;
    return this.http.withLoading().delete<TruckDriverBrief>(url, { body });
  }
}
